/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { mutatorAction } from "satcheljs";

import { SharedStateStore } from "../store/SharedStateStore";

/**
 * Sets the user locale in the shared state store.
 * User locale is a platform agnostic string representing the user's locale.
 * @example setLocale("en-US")
 */
export const setLocale = mutatorAction("setLocale", (locale: string) => {
    SharedStateStore().locale = locale;
});
